module.exports = __webpack_public_path__ + "img/process.92f56134.png";